import { defineMessages } from 'react-intl';

const messages = defineMessages({
  applyButton: {
    id: 'VisibilityOptions.ApplyButton',
    defaultMessage: 'Apply',
  },
  cancelButton: {
    id: 'VisibilityOptions.CancelButton',
    defaultMessage: 'Cancel',
  },
  resetButton: {
    id: 'VisibilityOptions.ResetButton',
    defaultMessage: 'Reset to Default',
  },
  selectAll: {
    id: 'VisibilityOptions.SelectAll',
    defaultMessage: 'Select All',
  },
  visibleFields: {
    id: 'VisibilityOptions.VisibleColumns',
    defaultMessage: 'Visible Fields',
  },
  tableOptions: {
    id: 'VisibilityOptions.VisibilityOptions',
    defaultMessage: 'Options',
  },
  buttonText: {
    id: 'VisibilityOptions.ButtonText',
    defaultMessage: 'Options',
  },
});

export default messages;
